/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react'
import withStyles from '@mui/styles/withStyles'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Colors from 'utils/Colors'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material'

import styles from './styles'

const summaryStyles = {
  root: {
    minHeight: 8 * 4,
    '&$expanded': {
      minHeight: 8 * 4,
    },
  },
  content: {
    margin: '8px 0',
    '&$expanded': {
      margin: '8px 0',
    },
  },
  expanded: {},
}

const expansionStyles = {
  root: {
    marginTop: 10,
    marginBottom: 5,
  },
}

const CustomExpansionPanel = withStyles(expansionStyles)((props) => {
  return <Accordion {...props} />
})

const CompactExpansionPanelSummary = withStyles(summaryStyles)((props) => {
  return <AccordionSummary {...props} />
})

CompactExpansionPanelSummary.muiName = 'AccordionSummary'

export function Expansible({
  title,
  children,
  color = '#EFEFEF',
  textColor = Colors.textColor,
  open,
}) {
  const classes = styles()

  const [expanded, setExpanded] = useState(open || false)

  return (
    <CustomExpansionPanel
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
    >
      <CompactExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        style={{
          padding: '0px 10px',
          backgroundColor: color,
        }}
      >
        <Typography
          variant="h6"
          className={classes.text}
          style={{ color: textColor }}
        >
          {title}
        </Typography>
      </CompactExpansionPanelSummary>

      <AccordionDetails style={{ padding: '10px 10px 20px' }}>
        <div style={{ width: '100%' }}>{children}</div>
      </AccordionDetails>
    </CustomExpansionPanel>
  )
}
